import { render, staticRenderFns } from "./UploadingIcon.vue?vue&type=template&id=151a02b6&scoped=true"
import script from "./UploadingIcon.vue?vue&type=script&lang=js"
export * from "./UploadingIcon.vue?vue&type=script&lang=js"
import style0 from "./UploadingIcon.vue?vue&type=style&index=0&id=151a02b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a02b6",
  null
  
)

export default component.exports